<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row">
        <h2 class="page-title">{{ $t("Printer sozlamalari") }}</h2>
        <button class="save-btn" @click="Settings()">
          <b-icon icon="check-circle-fill"></b-icon>
          {{ $t("Saqlash") }}
        </button>
      </div>

      <!-- Muvaffaqiyatli saqlandi -->
      <div class="alert-box" v-if="alert">
        <b-icon icon="check-circle-fill" style="color:#16a34a"></b-icon>
        {{ $t(alert) }}
      </div>

      <!-- Hidden electron printer component -->
      <div style="display:none">
        <electron-vue-printer ref="electronVuePrinter" :show="true" :silent="true"></electron-vue-printer>
      </div>

      <div class="settings-grid">

        <!-- PRINTERLAR -->
        <div class="settings-card">
          <div class="card-section-title">
            <b-icon icon="printer-fill" style="color:#a142f4"></b-icon>
            {{ $t("Printerlar") }}
          </div>

          <div class="field-row">
            <label class="field-label">{{ $t("Asosiy printer") }}</label>
            <div class="select-wrap">
              <v-select
                :clearable="false"
                :options="printerList"
                v-model="datas.printer_name"
                :reduce="n => n.name"
                label="name"
              >
                <template #search="{ attributes, events }">
                  <input ref="focused" class="vs__search" v-bind="attributes" v-on="events" aria-activedescendant="null" />
                </template>
              </v-select>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">{{ $t("Chek printer") }}</label>
            <div class="select-wrap">
              <v-select
                :clearable="false"
                :options="printerList"
                v-model="datas.check_printer_name"
                :reduce="n => n.name"
                label="name"
              ></v-select>
            </div>
          </div>
        </div>

        <!-- FIRMA MA'LUMOTLARI -->
        <div class="settings-card">
          <div class="card-section-title">
            <b-icon icon="building" style="color:#a142f4"></b-icon>
            {{ $t("Firma ma'lumotlari") }}
          </div>

          <div class="field-row">
            <label class="field-label">{{ $t("Firma nomi") }}</label>
            <input class="modern-input" v-model="datas.sender.firm_name" type="text" />
          </div>

          <div class="field-row">
            <label class="field-label">{{ $t("Manzil") }}</label>
            <input class="modern-input" v-model="datas.sender.address" type="text" />
          </div>

          <div class="field-row">
            <label class="field-label">Р/С</label>
            <input class="modern-input" v-model="datas.sender.p_c" type="text" />
          </div>

          <div class="field-row">
            <label class="field-label">МФО</label>
            <input class="modern-input" v-model="datas.sender.mfo" type="text" />
          </div>

          <div class="field-row">
            <label class="field-label">ОКЕД</label>
            <input class="modern-input" v-model="datas.sender.oked" type="text" />
          </div>

          <div class="field-row">
            <label class="field-label">ИНН</label>
            <input class="modern-input" v-model="datas.sender.inn" type="text" />
          </div>

          <div class="field-row">
            <label class="field-label">Директор</label>
            <input class="modern-input" v-model="datas.sender.director" type="text" />
          </div>

          <div class="field-row">
            <label class="field-label">QR kod</label>
            <input class="modern-input" v-model="datas.qrcode" type="text" />
          </div>

          <div class="field-row">
            <label class="field-label">Logotip</label>
            <div class="logo-section">
              <input type="file" style="display:none" id="files" ref="files" @change="UploadLogo()" />
              <button type="button" class="upload-btn" @click="$refs.files.click()">
                <b-icon icon="cloud-arrow-up-fill"></b-icon>
                {{ $t("Yuklash") }}
              </button>
              <div class="logo-preview" v-if="datas.file_name">
                <img :src="axios.defaults.baseURL + '/api/v1/uploads/' + datas.file_name" class="logo-img" />
                <button type="button" class="del-logo-btn" @click="DeleteLogo()">
                  <b-icon icon="trash-fill"></b-icon>
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import electronVuePrinter from "electron-vue-printer";
export default {
  name: "A4",
  components: { electronVuePrinter },
  data() {
    return {
      datas: {
        qrcode: "",
        printer_name: "",
        check_printer_name: "",
        file_name: null,
        sender: {
          firm_name: "",
          address: "",
          p_c: "",
          mfo: "",
          oked: "",
          inn: "",
          director: ""
        }
      },
      printerList: [],
      alert: ""
    };
  },
  mounted() {
    this.Load();
    this.printerList = this.$refs.electronVuePrinter.printerList;
  },
  methods: {
    Load() {
      axios.post("api/v1/sklad-settings", {
        sklad_id: localStorage.getItem('sklad_id'),
        key: 'a4_printer'
      }).then(res => {
        if (res.data.data == null) {
          this.Settings();
        } else {
          this.datas = JSON.parse(res.data.data);
          if (!this.datas.qrcode) this.datas.qrcode = "";
        }
      });
    },
    Settings() {
      axios.patch("api/v1/sklad-settings", {
        sklad_id: localStorage.getItem('sklad_id'),
        key: 'a4_printer',
        data: JSON.stringify(this.datas)
      }).then(res => {
        if (res.data.data != null) {
          this.alert = "Ma'lumotlar saqlandi!";
          setTimeout(() => { this.alert = ''; }, 3000);
        }
      });
    },
    UploadLogo() {
      const formData = new FormData();
      formData.append("file_name", this.$refs.files.files[0]);
      axios.post("api/v1/upload/image", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      }).then(res => {
        this.datas.file_name = res.data.file_name;
      });
    },
    DeleteLogo() {
      axios.post("api/v1/upload/delete-image", { file_name: this.datas.file_name }).then(res => {
        if (res.data.message) {
          this.datas.file_name = null;
          this.$bvToast.toast(this.$t("Rasm o'chirildi"), {
            variant: 'success',
            toaster: 'b-toaster-bottom-center'
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.g-page {
  padding: 24px;
  background: #f8fafc;
  min-height: 100vh;
}
.content-container {
  max-width: 1100px;
  margin: 0 auto;
}
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}
.save-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 44px;
  padding: 0 24px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
}
.alert-box {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 12px;
  padding: 12px 18px;
  color: #16a34a;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
}
.settings-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
.settings-card {
  background: white;
  border-radius: 24px;
  padding: 28px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.card-section-title {
  font-weight: 800;
  font-size: 16px;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 4px;
}
.field-row {
  display: grid;
  grid-template-columns: 130px 1fr;
  align-items: center;
  gap: 14px;
}
.field-label {
  font-weight: 600;
  color: #64748b;
  font-size: 13px;
  text-align: right;
  margin: 0;
}
.modern-input {
  height: 40px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 0 14px;
  font-size: 14px;
  color: #2d3748;
  width: 100%;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.modern-input:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.1);
}
.select-wrap {
  width: 100%;
}
.select-wrap /deep/ .vs__dropdown-toggle {
  min-height: 40px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 2px 8px;
}
.select-wrap /deep/ .vs__dropdown-toggle:focus-within {
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.1);
}
.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
}
.upload-btn {
  background: rgba(161, 66, 244, 0.08);
  color: #a142f4;
  border: 1px solid rgba(161, 66, 244, 0.2);
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}
.logo-preview {
  display: flex;
  align-items: center;
  gap: 8px;
}
.logo-img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}
.del-logo-btn {
  background: #fff1f2;
  color: #e11d48;
  border: none;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
